import { render, staticRenderFns } from "./Protocolos.vue?vue&type=template&id=7228553c&scoped=true"
import script from "./Protocolos.vue?vue&type=script&lang=js"
export * from "./Protocolos.vue?vue&type=script&lang=js"
import style0 from "./Protocolos.vue?vue&type=style&index=0&id=7228553c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228553c",
  null
  
)

export default component.exports